import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyle = createGlobalStyle`
:root{}

${reset}

`;

export default GlobalStyle;
